import { render, staticRenderFns } from "./SwitchVersion.vue?vue&type=template&id=78e2c8b8&scoped=true&"
import script from "./SwitchVersion.vue?vue&type=script&lang=js&"
export * from "./SwitchVersion.vue?vue&type=script&lang=js&"
import style0 from "./SwitchVersion.vue?vue&type=style&index=0&id=78e2c8b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e2c8b8",
  null
  
)

export default component.exports